import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=77bc305a&scoped=true&"
import script from "./AddForm.vue?vue&type=script&lang=js&"
export * from "./AddForm.vue?vue&type=script&lang=js&"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=77bc305a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc305a",
  null
  
)

export default component.exports